// extracted by mini-css-extract-plugin
export var video = "ContentfulVideo-module--video--RYWKR";